import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Dropdown } from 'react-bootstrap'
import '../../styles/overview.scss'
import clsx from 'clsx'
import { KTSVG, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import threeDots from '../../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import { Filter } from '../../../widgets/components/General/Filter'
import Reports from './Reports'
import ReportSchedule from './ReportSchedule'
import ReportTemplates from './ReportTemplates'
import { useThemeMode } from '../../../../../_metronic/partials'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'
import { useAuth } from '../../../auth'
import { exportCSV } from '../../core/_requests'
import { toast } from 'react-toastify'
import GenerateReportModal from './GenerateReportModal'
import ScheduleReportModal from './ScheduleReportModal'
import TemplateReportModal from './TemplateReportModal'
import { useStakeholders } from '../../../stakeholders/Stakeholders'

const ReportGeneration = () => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const { mode } = useThemeMode()
  const [tabKey, setTabKey] = useState<number | null>(1)
  const {
    setSelectedReportFilter,
    selectedReportTypeFilter,
    setSelectedScheduleFilter,
    selectedScheduleTypeFilter,
  } = useStakeholders()
  const [generateModal, setGenerateModal] = useState(false)
  const [scheduleModal, setScheduleModal] = useState(false)
  const [TemplateModal, setTemplateModal] = useState(false)
  const [searchReport, setReportSearch] = useState<string>('')
  const [searchSchedule, setScheduleSearch] = useState<string>('')
  const [searchTemplate, setTemplateSearch] = useState<string>('')

  const exportToCsv = async (tabKey: number | null) => {
    if (!companyId) return
    const typeMap: Record<number, string> = {
      1: 'Reports',
      2: 'Schedule',
      3: 'Template',
    }
    const type = typeMap[tabKey ?? 1]
    try {
      const {
        data: { data: values, success },
      } = await exportCSV(companyId, type)
      if (success) {
        toast.success(formatMessage({ id: `${type} data exported successfully` }))
        const url = window.URL.createObjectURL(new Blob([values]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'reports.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (tabKey === 1) {
      setScheduleSearch('')
      setTemplateSearch('')
    }
    if (tabKey === 2) {
      setReportSearch('')
      setTemplateSearch('')
    }
    if (tabKey === 3) {
      setReportSearch('')
      setScheduleSearch('')
    }
  }, [tabKey])

  return (
    <>
      <div>
        <div className='d-flex h-55px border-bottom space-between w-100 justify-content-between prospective-investor-tab'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap mobile-tab-both'>
            <li className='nav-item mobile-tab font-size-13'>
              <div
                className={`nav-link text-active-primary me-2 cursor-pointer ${tabKey === 1 ? 'active' : ''
                  }`}
                onClick={() => setTabKey(1)}
              >
                {formatMessage({ id: 'Reports' })}
              </div>
            </li>
            <li className='nav-item mobile-tab font-size-13'>
              <div
                className={`nav-link text-active-primary me-2 cursor-pointer ${tabKey === 2 ? 'active' : ''
                  }`}
                onClick={() => setTabKey(2)}
              >
                {formatMessage({ id: 'Schedule Report' })}
              </div>
            </li>
            <li className='nav-item mobile-tab font-size-13'>
              <div
                className={`nav-link text-active-primary me-2 cursor-pointer ${tabKey === 3 ? 'active' : ''
                  }`}
                onClick={() => setTabKey(3)}
              >
                {formatMessage({ id: 'Templates' })}
              </div>
            </li>
          </ul>
          {/* For Desktop */}
          <div className='d-md-flex d-none gap-md-2 gap-2 align-items-center flex-wrap flex-md-nowrap'>
            <div
              className='h-72 border d-flex rounded'
              onClick={() => {
                if (tabKey === 1) {
                  setSelectedReportFilter(true)
                }
                if (tabKey === 2) {
                  setSelectedScheduleFilter(true)
                }
                if (tabKey === 3) {
                  setSelectedReportFilter(true)
                }
              }}
            >
              <button
                className={clsx('text-clr88 bg-white btn btn-sm btn-flex fw-semibold border-none font-size-12 height-36')}
                id='fc-toogle'
                title='Sort and Filter'
                data-bs-toggle='tooltip'
                data-bs-placement='left'
                data-bs-dismiss='click'
                data-bs-trigger='hover'
              >
                <KTSVG
                  path={toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')}
                  className='svg-icon-6 svg-icon-muted me-1'
                />
                <span className='d-none d-md-block'>{formatMessage({ id: 'Filter' })}</span>
                {tabKey === 1 && (selectedReportTypeFilter ? '*' : '')}
                {tabKey === 2 && (selectedScheduleTypeFilter ? '*' : '')}
                {tabKey === 3 && (selectedReportTypeFilter ? '*' : '')}
              </button>
            </div>
            <div className='border d-flex align-items-center bg-white rounded m-0 p-0 height-36'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-3 position-absolute ms-3'
              />
              <input
                type='text'
                className='bg-body form-control form-control-flush w-100 ps-10 rounded-2 font-size-13 font-weight-400 p-md-5 ps-md-10 p-2 height-36 '
                name='search'
                value={
                  tabKey === 1
                    ? searchReport
                    : tabKey === 2
                      ? searchSchedule
                      : tabKey === 3
                        ? searchTemplate
                        : ''
                }
                placeholder={formatMessage({ id: 'Search' })}
                data-kt-search-element='input'
                onChange={(e: any) => {
                  if (tabKey === 1) {
                    setReportSearch(e?.target.value)
                  }
                  if (tabKey === 2) {
                    setScheduleSearch(e?.target.value)
                  }
                  if (tabKey === 3) {
                    setTemplateSearch(e?.target.value)
                  }
                }}
              />
            </div>
            <div className='w-button-mobile'>
              {/* <button
                className='btn btn-bg-primary font-size-13 text-white font-weight-400 height-36 d-flex justify-content-center align-items-center w-100 p-6'
                onClick={() => {
                  if (tabKey === 1) {
                    setGenerateModal(true);
                  } else if (tabKey === 2) {
                    setScheduleModal(true);
                  } else {
                    setTemplateModal(true);
                  }
                }}
              >
                {tabKey === 1
                  ? formatMessage({ id: 'Generate New Report' })
                  : tabKey === 2
                    ? formatMessage({ id: 'Schedule Report' })
                    : formatMessage({ id: 'New Template' })}
              </button> */}
              <Dropdown className='bg-primary custom-button-property text-white'>
                <Dropdown.Toggle
                  id='dropdown-custom-components'
                  className='btn btn-primary justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-100'
                >
                  {formatMessage({ id: 'Generate Report' })}
                </Dropdown.Toggle>
                <Dropdown.Menu className='p-0'>
                  <Dropdown.Item
                    className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                    onClick={() => setGenerateModal(true)}
                  >
                    {formatMessage({ id: 'New Report' })}
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                    onClick={() => setScheduleModal(true)}
                  >
                    {formatMessage({ id: 'Schedule Report' })}
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                    onClick={() => setTemplateModal(true)}
                  >
                    {formatMessage({ id: 'Create Template' })}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className='d-flex align-items-center position-relative'>
              <div className='dropdown-export-container'>
                <Dropdown>
                  <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                    <img src={threeDots} alt='' className='three-dots-image' />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className='m-1'>
                    <Dropdown.Item
                      className='text-dark ps-5'
                      onClick={() => {
                        exportToCsv(tabKey)
                      }}
                    >
                      {formatMessage({ id: 'Export to CSV' })}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          {/* For Mobile */}
          <div className='d-flex flex-column d-md-none gap-2 mb-2'>
            <div className='d-flex gap-2'>
              <div
                className='h-72 border d-flex rounded w-100'
                onClick={() => {
                  if (tabKey === 1) {
                    setSelectedReportFilter(true)
                  }
                  if (tabKey === 2) {
                    setSelectedScheduleFilter(true)
                  }
                  if (tabKey === 3) {
                    setSelectedReportFilter(true)
                  }
                }}
              >
                <button
                  className={clsx('text-clr88 bg-white btn btn-sm btn-flex fw-semibold border-none font-size-12 height-36')}
                  id='fc-toogle'
                  title='Sort and Filter'
                  data-bs-toggle='tooltip'
                  data-bs-placement='left'
                  data-bs-dismiss='click'
                  data-bs-trigger='hover'
                >
                  <KTSVG
                    path={toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')}
                    className='svg-icon-6 svg-icon-muted me-1'
                  />
                  <span className='d-none d-md-block'>{formatMessage({ id: 'Filter' })}</span>
                  {tabKey === 1 && (selectedReportTypeFilter ? '*' : '')}
                  {tabKey === 2 && (selectedScheduleTypeFilter ? '*' : '')}
                  {tabKey === 3 && (selectedReportTypeFilter ? '*' : '')}
                </button>
                <div className='border d-flex align-items-center bg-white rounded m-0 p-0 height-36 ms-2 w-100'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-3 position-absolute ms-3'
                  />
                  <input
                    type='text'
                    className='bg-body form-control form-control-flush w-100 ps-10 rounded-2 font-size-13 font-weight-400 p-md-5 ps-md-10 p-2 height-36 w-100'
                    name='search'
                    value={
                      tabKey === 1
                        ? searchReport
                        : tabKey === 2
                          ? searchSchedule
                          : tabKey === 3
                            ? searchTemplate
                            : ''
                    }
                    placeholder={formatMessage({ id: 'Search' })}
                    data-kt-search-element='input'
                    onChange={(e: any) => {
                      if (tabKey === 1) {
                        setReportSearch(e?.target.value)
                      }
                      if (tabKey === 2) {
                        setScheduleSearch(e?.target.value)
                      }
                      if (tabKey === 3) {
                        setTemplateSearch(e?.target.value)
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='d-flex gap-2'>
              <Dropdown className='bg-primary custom-button-property text-white w-100'>
                <Dropdown.Toggle
                  id='dropdown-custom-components'
                  className='btn btn-primary justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-100'
                >
                  {formatMessage({ id: 'Generate Report' })}
                </Dropdown.Toggle>
                <Dropdown.Menu className='p-0'>
                  <Dropdown.Item
                    className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                    onClick={() => setGenerateModal(true)}
                  >
                    {formatMessage({ id: 'New Report' })}
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                    onClick={() => setScheduleModal(true)}
                  >
                    {formatMessage({ id: 'Schedule Report' })}
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                    onClick={() => setTemplateModal(true)}
                  >
                    {formatMessage({ id: 'Create Template' })}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className='d-flex align-items-center position-relative'>
                <div className='dropdown-export-container'>
                  <Dropdown>
                    <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                      <img src={threeDots} alt='' className='three-dots-image' />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className='m-1'>
                      <Dropdown.Item
                        className='text-dark ps-5'
                        onClick={() => {
                          exportToCsv(tabKey)
                        }}
                      >
                        {formatMessage({ id: 'Export to CSV' })}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <Filter />
        </div>

        {tabKey === 1 && (
          <>
            <div className='mt-4'>
              <InfoCard2
                title={'Understanding Your Reports List'}
                desc={
                  'This page provides an overview of all reports generated by you within RecordsKeeper. Here, you can view details such as the report name, type, file size, generation date, and status. Use the available filters to sort or search for specific reports based on your needs. Access reports directly by downloading them or track the generation progress for ongoing reports. This section helps you manage your Access and Activity reports with a user-friendly, organized layout.'
                }
                slug={
                  'https://help.recordskeeper.ai/en/articles/10374124-how-to-manage-and-access-your-reports-in-recordskeeper-ai'
                }
              />
            </div>
            <Reports
              setTabKey={setTabKey}
              isActive={generateModal}
              setIsActive={setGenerateModal}
              selectedReportTypeFilter={selectedReportTypeFilter}
              search={searchReport}
            />
          </>
        )}

        {tabKey === 2 && (
          <>
            <div className='mt-4'>
              <InfoCard2
                title={'Scheduled Reports for Automated Delivery'}
                desc={
                  'This page lists all scheduled reports in RecordsKeeper that are set to be generated and delivered automatically. Users can configure reports to be generated periodically without re-entering the details each time. Simply set the frequency and time period for recurring reports. This feature ensures timely updates and consistency in report delivery, saving you time on manual report generation.'
                }
                slug={''}
              />
            </div>
            <ReportSchedule
              setTabKey={setTabKey}
              isActive={scheduleModal}
              setIsActive={setScheduleModal}
              selectedScheduleTypeFilter={selectedScheduleTypeFilter}
              search={searchSchedule}
            />
          </>
        )}

        {tabKey === 3 && (
          <>
            <div className='mt-4'>
              <InfoCard2
                title={'Using Report Templates for Quick Access'}
                desc={
                  'This page displays a list of templates in RecordsKeeper that you can use to generate reports efficiently. Each template is preconfigured with specific details, allowing you to create reports without needing to re-enter information. Simply select a time period when using a template to generate a report tailored to your needs. Templates streamline the report creation process, saving time and ensuring consistency.'
                }
                slug={
                  'https://help.recordskeeper.ai/en/articles/10411563-how-report-templates-can-be-used-for-creating-quick-reports'
                }
              />
            </div>
            <ReportTemplates
              setTabKey={setTabKey}
              isActive={TemplateModal}
              setIsActive={setTemplateModal}
              selectedReportTypeFilter={selectedReportTypeFilter}
              search={searchTemplate}
            />
          </>
        )}
        <GenerateReportModal
          isActive={generateModal}
          setIsActive={setGenerateModal}
          setTabKey={setTabKey}
        />
        <ScheduleReportModal
          isActive={scheduleModal}
          setIsActive={setScheduleModal}
          setTabKey={setTabKey}
        />
        <TemplateReportModal
          isActive={TemplateModal}
          setIsActive={setTemplateModal}
          setTabKey={setTabKey}
        />
        <Filter />
      </div>
    </>
  )
}

export default ReportGeneration
